import {
    WebPushNotificationsOptions,
    getOptionsForFeature,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';

export function getWebPushNotificationsOption(): WebPushNotificationsOptions {
    let options = getOptionsForFeature<WebPushNotificationsOptions>(
        OwsOptionsFeatureType.WebPushNotifications
    );

    return options;
}
